import { render, staticRenderFns } from "./SearchResults.vue?vue&type=template&id=37623187&"
import script from "./SearchResults.vue?vue&type=script&lang=js&"
export * from "./SearchResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/gcg3.devserver6.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37623187')) {
      api.createRecord('37623187', component.options)
    } else {
      api.reload('37623187', component.options)
    }
    module.hot.accept("./SearchResults.vue?vue&type=template&id=37623187&", function () {
      api.rerender('37623187', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/SearchResults.vue"
export default component.exports